import { MultiPlateUpdate, PlateUpdateInfo } from './multiplate-update-dto';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MessagesService } from '../messages/messages.service';
import { Comment } from '../models/comment';
import { Plate } from '../models/plate';
import { Sample } from '../models/sample';
import { ProcessStepStage } from '../models/process-step-stages';
import { Step } from '../models/step';
import { StepAction } from '../models/step-action';
import { ErrorHandler } from '../utils/error-handler';
import { MaPlatePreparationService } from './ma-plate-preparation.service';
import { ProcessStep, PlateStatus } from '../models/process-step';
import { Action } from '../models/action';
import { ActivatedRoute } from '@angular/router';
import { MultiCommentDTO } from '../ma-comments-popup/comment-dto';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { Machine } from '../masterdata/models/machine';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { BeadChipProcessFlows } from '../models/process-flows';
import '../utils/group-by';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { priorityMap } from '../utils/priority-row';
import { axiom384PropelStatusFilter, illuminaExInfiniumStatusFilter } from '../utils/plate-filter';
import {showLatestComment} from "../utils/latest-comment-util";
import { formatDate,DatePipe } from "@angular/common";
import { PlateListDTO } from '../dto/plateListDTO';

@Component({
  selector: 'app-ma-plate-preparation',
  templateUrl: './ma-plate-preparation.component.html',
  styleUrls: ['./ma-plate-preparation.component.css']
})
export class MaPlatePreparationComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;

  selectedLabId: string;
  puid: string;
  // table properties and values
  processSteps: any[];
  filterOptions: any[];
  selectedStatuses: string[] = [];
  blocked = false;
  loading: boolean;
  fromDate: Date = new Date();

  workFlowList = [];
  workFlowData: WorkFlow[] = [];
  protocolsList = [];
  selectedProtocolList: string[] = [];
  selectedProcessFlowList: string[] = [];

  @Input() plates: Plate[] = [];
  showDueDate = false;
  plate: Plate;
  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;
  multiPlateStepsMap: Map<string, Step>;
  multiPlateStepsMapList: Array<Map<string, Step>>;
  scanDialogMessage = 'Scan RNA Plate changes not yet saved. Do you wish to proceed?';
  mapOfStatusSaves = new Map();
  mapOfStatusAndLabel = new Map();
  mapOfProcessStepsStatus = new Map();

  previewComment: Comment;

  plateToSearch: string;
  sampleToSearch: string;

  plateHistory: any[];
  plateHistoryId: string;
  showPlateView: boolean;
  mapOfActionRuntime : Map<string, number> = new Map();

  mapOfStatus = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  mapOfProcessStepAndAction : Map<string, string[]> = new Map();
  showDialogue= false;
  showMultipleCommentDialog = false;
  enteredPuid: string;
  enteredPassword: string;
  enteredPasswordToByeArray: any[];
  puidPopup: boolean = false;
  puidPopupFunction: string;

  plateBtn:string;
  flag:boolean=true;
  isVisible:boolean=false;
  plateMap = new Map();
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  BcolumnHeaders=["C01","C02","C03"];
  BrowHeaders=['R01','R02','R03','R04','R05','R06','R07','R08','R09','R10','R11','R12','R13','R14','R15','R16'];
  wgaPGXStatus = [PlateStatus.START_PREPCR, PlateStatus.PREPCR_COMPLETED, PlateStatus.WGA_COMPLETED, PlateStatus.PGX_COMPLETED]
  typeOfView:string;
  plateBtn1:string;
  enteredPlateId : string ="";
  enteredWgaPlateId : string ="";
  enteredPgxPlateId : string ="";
  fetchedPlate : Plate;
  multiUpdatePlateList : string[]=[];
  multiPlateUpdateListForRecombine : PlateUpdateInfo[] = [];
  multiPlate = true;
  showConfirmPlatesPopup = false;
  showConfirmPlatesPopupForRecombine = false;
  multiUpdatePlateListSave : string[]=[];
  multiUpdatePlateInfoList: PlateUpdateInfo[]=[];
  showStartWGAorPGXMultiPlateUpdate = false;
  multiStage: number;
  multiStepName: string;
  multiActionName: string;
  multiActionPos: number;
  multiUpdateStatus : string;
  multiUpdateStatusLabel: string;
  multiUpdateInputLabel: string;
  multiUpdatePlateType: string;
  multiUpdateButtonStyleClass : string;
  multiUpdateSelectedWorkFlow: string = "";

  countBox = 2;
  boxName = 0;
  processStep: string;
  noChemicalEdit : boolean;
  chemicalsPlateids: any[] = [];
  multiChemicalEdit: boolean;

  showCommentDialog : boolean = false;
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  plateCommentsList: Comment[]=[];
  fetchedCommentsPlate : Plate;
  selectedPlateID : string ="";
  selectedPlateStatus:string="";
  enteredWGAPlateId: string ="";
  enteredPGXPlateId:string = "";
  pgxPlateIDPlaceHolder:string ="Scan PGX Plate";
  tableSelectedRow :Plate;
  selectedProcessStep: string;
  processStepChemicals: any;
  multiUpdateWGAPlateListSave:string[]=[];
  multiUpdatePlateInfoList1: PlateUpdateInfo[]=[];
  multiUpdatePGXPlateListSave:string[]=[];

  beadchipSamplesMap: Map<string, Map<string, Sample>> = new Map();
  lastUpdatedPlates1: any[] = []
  lastUpdatedPlates2: any[] = []
  lastUpdatedPlates3: any[] = []
  lastUpdatedStatus: string;
  newMultiComment: string = '';

  multiUpdateProcessStepsMap: Map<string, Step>

  isFileNotSelected : boolean = true;
  uploadedFile : File;
  uploadedFileContent : any;
  @ViewChild('manualfileUpload')
  fileUploadElement: ElementRef;
  selectedStorage: Storage = null;
  storageList: Array<any> = [];
  recombineDnaStorageList : Array<any> = [];
  precipitateDnaStorageList : Array<any> = [];
  resuspendDnaStorageList: Array<any> = [];
  fragmentDnaStorageList : Array<any> = [];


  @Input() machinesList: Machine[];
  multiLiquidHandler: string = '';
  amplifyLiquidHandler: string = '';
  recombineLiquidHandler: string = '';
  precipitateLiquidHandler: string = '';
  resuspendLiquidHandler: string = '';
  machineProcessStepStatusMap = new Map();
  selectedProcessFlows: ProcessFlow[] = [];
  statusFilterList: string[] = [];
  @Input() isPlatePreparationSelectedFromSamplesComponent: any;
  @Input() scannedPlateID: string = null;

  viewType = BeadChipProcessFlows.OLD_FLOW;
  processFlowObject = null;
  selectedProcessFlow: ProcessFlow = null;
  mapOfActionRuntimeAxiom384: Map<string, number> = new Map();
  mapOfProcessStepAndActionAxiom384:Map<string, string[]> = new Map();
  mapOfProcessStepsFlowAxiom384 : Map<string, string[]> = new Map();
  workFlowBeadchip: string= ''
  beadChipID: string = ''
  beadChipDetails: Plate
  processFlows: ProcessFlow[] = []
  sampleTypeAliquotVolumeMap= []
  aliquotPlateID: string = '';
  plateViewSelectionDone: boolean = false;
  validRestorationSteps = [ProcessStep.WGA_AND_PGX, ProcessStep.FRAGMENT_DNA, ProcessStep.AMPLIFY_PGX, ProcessStep.AMPLIFY_WGA,ProcessStep.PRECIPITATE_DNA,ProcessStep.RESUSPEND_DNA]
  validStorageSteps = [ProcessStep.SAFE_STOPPING,ProcessStep.STORE_PGX_PLATE,ProcessStep.FRAGMENT_SAFE_STOPPING,ProcessStep.RESUSPEND_SAFE_STOPPING,ProcessStep.PRECIPITATE_SAFE_STOPPING]

  constructor(
      private readonly masterDataService: MasterDataService,
      private readonly _messagesService: MessagesService,
      private readonly _maStorageService: MaStorageService,
      private readonly announcementService:AnnouncedService,
      private readonly platePreparationService: MaPlatePreparationService,
      private readonly activatedRoute: ActivatedRoute,
      private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.workFlowData = JSON.parse(localStorage.getItem('workFlowData'));
    const isDateRange = JSON.parse(localStorage.getItem('lab')).lab.dateRange;
    this.showPlateView = false;
    this.isPlatePreparationSelectedFromSamplesComponent = false;
    this.checkProcessFlowProperties();
    this.getStorageLocations();
    this.getAllProcessFlows()
    this.filterOptions = [
      { label: 'Stored', value: PlateStatus.STORED},
      { label: 'Extraction Completed', value: PlateStatus.EXTRACTION_COMPLETED},
      { label: 'Start Aliquotation', value: PlateStatus.ALIQUOTATION_STARTED},
      { label: 'Complete Aliquotation', value: PlateStatus.ALIQUOTATION_COMPLETED},
      { label: 'Prepcr Started', value: PlateStatus.START_PREPCR},
      { label: 'WGA Completed', value: PlateStatus.WGA_COMPLETED},
      { label: 'PGX Completed', value: PlateStatus.PGX_COMPLETED},
      { label: 'Prepcr Completed', value: PlateStatus.PREPCR_COMPLETED},
      { label: 'Recombining Started', value: PlateStatus.RECOMBINING_STARTED},
      { label: 'Recombining Completed', value: PlateStatus.RECOMBINING_COMPLETED},
      { label: 'Fragmentation Started', value: PlateStatus.FRAGMENTATION_STARTED},
      { label: 'Fragmentation Completed', value: PlateStatus.FRAGMENTATION_COMPLETED},
      { label: 'Precipitation Started', value: PlateStatus.PRECIPITATION_STARTED},
      { label: 'Precipitation Completed', value: PlateStatus.PRECIPITATION_COMPLETED},
      { label: 'Resuspending Started', value: PlateStatus.RESUSPENDING_STARTED},
      { label: 'Resuspending Completed', value: PlateStatus.RESUSPENDING_COMPLETED},
      { label: 'Denaturation Started', value: PlateStatus.DENATURATION_STARTED},
      { label: 'Denaturation Completed', value: PlateStatus.DENATURATION_COMPLETED},
      { label: 'Completly Transfered', value: PlateStatus.COMPLETLY_TRANSFERED},
      { label: 'Completed', value: PlateStatus.COMPLETED},
    ];
    this.protocolsList = [
      { label: "Illumina Ex Infinium", value: "illuminaExInfinium"},
      { label: "Axiom384 Propel", value: "axiom384Propel"},
    ]
    this.multiPlate = true;
    this.getAllActiveWorkFlowList();
    if (isDateRange) {
      this.fromDate.setDate(new Date().getDate() - 5);
    } else {
      this.fromDate.setDate(new Date().getDate() - 31);
    }
    this.fetchReceivedPlates();
    this.selectedPlate = new Plate();
    this.selectedPlateStepsMap = new Map();
    this.multiUpdateProcessStepsMap = new Map();
    this.multiPlateStepsMap = new Map();
    this.multiPlateStepsMapList = new Array();
    this.mapOfStatusSaves.set(PlateStatus.START_PREPCR, "startWGAandPGX");
    this.mapOfStatusSaves.set(PlateStatus.WGA_STARTED, "startWGA");
    this.mapOfStatusSaves.set(PlateStatus.ALIQUOTATION_STARTED, "startAliquotation")
    this.mapOfStatusSaves.set(PlateStatus.ALIQUOTATION_COMPLETED, "completeAliquotation")
    this.mapOfStatusSaves.set(PlateStatus.WGA_COMPLETED, "completeWGA");
    this.mapOfStatusSaves.set(PlateStatus.PGX_COMPLETED, "completePGX");
    this.mapOfStatusSaves.set(PlateStatus.RECOMBINING_STARTED, "startRecombining");
    this.mapOfStatusSaves.set(PlateStatus.RECOMBINING_COMPLETED, "completeRecombining");
    this.mapOfStatusSaves.set(PlateStatus.PGX_PLATE_STORED, "storePgxPlate");
    this.mapOfStatusSaves.set(PlateStatus.FRAGMENTATION_STARTED, "startFragmentation");
    this.mapOfStatusSaves.set(PlateStatus.FRAGMENTATION_COMPLETED, "completeFragmentation");
    this.mapOfStatusSaves.set(PlateStatus.PRECIPITATION_STARTED, "startPrecipitation");
    this.mapOfStatusSaves.set(PlateStatus.PRECIPITATION_COMPLETED, "completePrecipitation");
    this.mapOfStatusSaves.set(PlateStatus.RESUSPENDING_STARTED, "startResuspending");
    this.mapOfStatusSaves.set(PlateStatus.RESUSPENDING_COMPLETED, "completeResuspending");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_STARTED, "startDenaturation");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_COMPLETED, "completeDenaturation");
    this.mapOfStatusSaves.set(PlateStatus.FRAGMENT_WGA_PLATE_STORED, "fragmentDnaSafeStopping");
    this.mapOfStatusSaves.set(PlateStatus.RESUSPEND_WGA_PLATE_STORED, "resuspendDnaSafeStopping");
    this.mapOfStatusSaves.set(PlateStatus.PRECIPITATE_WGA_PLATE_STORED, "precipitateDnaSafeStopping");
    this.mapOfStatusSaves.set(Action.INCUBATE_WGA_37C, "actionIncubateWGA37c");
    this.mapOfStatusSaves.set(Action.CENTRIFUGE, "actionCentrifuge");
    this.mapOfStatusSaves.set(Action.MAX_DRYING_TIME, "actionMaxDryingTime");
    this.mapOfStatusSaves.set(Action.INCUBATE_95C, "actionIncubate95c");
    this.mapOfStatusSaves.set(Action.INCUBATE_RT, "actionIncubateRT");
    this.mapOfStatusSaves.set(Action.INCUBATE_48C, "actionIncubateRT");
    this.mapOfStatusSaves.set(Action.RUN_THERMO_CYCLER, "actionRunThermoCycler");
    this.mapOfStatusSaves.set(Action.INCUBATE_37C, "actionIncubate37c");
    this.mapOfStatusSaves.set(Action.INCUBATION_58C, "actionIncubation58c");

    this.mapOfStatusAndLabel.set(PlateStatus.START_PREPCR, "Start Prepcr.")
    this.mapOfStatusAndLabel.set(PlateStatus.WGA_STARTED, "Start WGA")
    this.mapOfStatusAndLabel.set(PlateStatus.ALIQUOTATION_STARTED, "startAliquotation")
    this.mapOfStatusAndLabel.set(PlateStatus.ALIQUOTATION_COMPLETED, "completeAliquotation")

    this.mapOfStatusAndLabel.set(Action.INCUBATE_WGA_37C, "Incubate WGA 37°C")
    this.mapOfStatusAndLabel.set(PlateStatus.WGA_COMPLETED, "Complete WGA")
    this.mapOfStatusAndLabel.set(Action.RUN_THERMO_CYCLER, "Run Thermo Cycler")
    this.mapOfStatusAndLabel.set(PlateStatus.PGX_COMPLETED, "Complete PGx")
    this.mapOfStatusAndLabel.set(PlateStatus.RECOMBINING_STARTED, "Start Recombine")
    this.mapOfStatusAndLabel.set(PlateStatus.RECOMBINING_COMPLETED, "Complete Recombine")
    this.mapOfStatusAndLabel.set(PlateStatus.STORED, "Safe Stopping")
    this.mapOfStatusAndLabel.set(PlateStatus.PGX_PLATE_STORED,"Store PGX Plate")
    this.mapOfStatusAndLabel.set(PlateStatus.RESUSPEND_WGA_PLATE_STORED,"Store WGA Plate Resuspend")
    this.mapOfStatusAndLabel.set(PlateStatus.PRECIPITATE_WGA_PLATE_STORED,"Store WGA Plate Precipitate")
    this.mapOfStatusAndLabel.set(PlateStatus.FRAGMENT_WGA_PLATE_STORED,"Store WGA Plate Fragment")
    this.mapOfStatusAndLabel.set(PlateStatus.FRAGMENTATION_STARTED,"Start Fragmen.")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_37C, "Incubate 37°C")
    this.mapOfStatusAndLabel.set(PlateStatus.FRAGMENTATION_COMPLETED,"Complete Fragmen.")
    this.mapOfStatusAndLabel.set(PlateStatus.PRECIPITATION_STARTED,"Start Precipitation")
    this.mapOfStatusAndLabel.set(Action.CENTRIFUGE, "Centrifuge")
    this.mapOfStatusAndLabel.set(Action.MAX_DRYING_TIME, "Max Drying Time")
    this.mapOfStatusAndLabel.set(PlateStatus.PRECIPITATION_COMPLETED,"Complete Precipit.")
    this.mapOfStatusAndLabel.set(PlateStatus.RESUSPENDING_STARTED,"Start Resus.")
    this.mapOfStatusAndLabel.set(Action.INCUBATION_58C, "Incubation 58°C")
    this.mapOfStatusAndLabel.set(PlateStatus.RESUSPENDING_COMPLETED,"Complete Resus.")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_STARTED,"Start Denaturation")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_95C, "Incubate 95°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_RT, "Incubate RT")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_48C, "Incubate 48°C")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_COMPLETED,"Complete Denatu.")

    this.mapOfProcessStepsStatus.set(PlateStatus.ANNOUNCED,[]);
    this.mapOfProcessStepsStatus.set(PlateStatus.RECEIVED,[]);
    this.mapOfProcessStepsStatus.set(PlateStatus.STORED,[]);
    this.mapOfProcessStepsStatus.set(PlateStatus.ALIQUOTATION_STARTED, [ProcessStep.ALIQUOTATION])
    this.mapOfProcessStepsStatus.set(PlateStatus.ALIQUOTATION_COMPLETED, [ProcessStep.ALIQUOTATION])
    this.mapOfProcessStepsStatus.set(PlateStatus.START_PREPCR,[ProcessStep.AMPLIFY_WGA,ProcessStep.AMPLIFY_PGX]);
    this.mapOfProcessStepsStatus.set(PlateStatus.WGA_STARTED,[ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_WGA_37C,[ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(Action.RUN_THERMO_CYCLER,[ProcessStep.AMPLIFY_PGX]);
    this.mapOfProcessStepsStatus.set(PlateStatus.WGA_COMPLETED, [ProcessStep.AMPLIFY_PGX]);
    this.mapOfProcessStepsStatus.set(PlateStatus.PGX_COMPLETED, [ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.PREPCR_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.RECOMBINING_STARTED,[ProcessStep.RECOMBINE_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.RECOMBINING_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.FRAGMENTATION_STARTED,[ProcessStep.FRAGMENT_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_37C,[ProcessStep.FRAGMENT_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.FRAGMENTATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.PRECIPITATION_STARTED,[ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.CENTRIFUGE,[ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.MAX_DRYING_TIME,[ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.PRECIPITATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.RESUSPENDING_STARTED,[ProcessStep.RESUSPEND_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATION_58C,[ProcessStep.RESUSPEND_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.RESUSPENDING_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.DENATURATION_STARTED,[ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_95C,[ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_RT,[ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_48C,[ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.DENATURATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETLY_TRANSFERED,[]);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETED,[]);

    // This map holds the flow of process steps that a plate has to go through
    this.mapOfProcessStepsFlow.set(ProcessStep.AMPLIFY_WGA, [ProcessStep.RECEIVE_PLATE])
    this.mapOfProcessStepsFlow.set(ProcessStep.AMPLIFY_PGX, [ProcessStep.RECEIVE_PLATE])
    this.mapOfProcessStepsFlow.set(ProcessStep.RECOMBINE_DNA, [ProcessStep.AMPLIFY_WGA, ProcessStep.AMPLIFY_PGX])
    this.mapOfProcessStepsFlow.set(ProcessStep.STORE_PGX_PLATE, [ProcessStep.RECOMBINE_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.FRAGMENT_DNA, [ProcessStep.RECOMBINE_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.FRAGMENT_SAFE_STOPPING,[ProcessStep.FRAGMENT_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.PRECIPITATE_DNA, [ProcessStep.FRAGMENT_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.PRECIPITATE_SAFE_STOPPING,[ProcessStep.PRECIPITATE_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.RESUSPEND_DNA, [ProcessStep.PRECIPITATE_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.DENATURATE_DNA, [ProcessStep.RESUSPEND_DNA])
    this.mapOfProcessStepsFlow.set(ProcessStep.RESUSPEND_SAFE_STOPPING,[ProcessStep.RESUSPEND_DNA])

    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.ALIQUOTATION, [ProcessStep.RECEIVE_PLATE]);
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.AMPLIFY_WGA, [ProcessStep.ALIQUOTATION]);
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.FRAGMENT_DNA, [ProcessStep.AMPLIFY_WGA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.PRECIPITATE_DNA, [ProcessStep.FRAGMENT_DNA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.RESUSPEND_DNA, [ProcessStep.PRECIPITATE_DNA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.DENATURATE_DNA, [ProcessStep.RESUSPEND_DNA])

    this.mapOfProcessStepAndAction.set(ProcessStep.AMPLIFY_WGA, [Action.INCUBATE_WGA_37C])
    this.mapOfProcessStepAndAction.set(ProcessStep.PRECIPITATE_DNA, [Action.CENTRIFUGE, Action.MAX_DRYING_TIME])
    this.mapOfProcessStepAndAction.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C, Action.INCUBATE_RT])
    this.mapOfProcessStepAndAction.set(ProcessStep.AMPLIFY_PGX, [Action.RUN_THERMO_CYCLER])
    this.mapOfProcessStepAndAction.set(ProcessStep.FRAGMENT_DNA, [Action.INCUBATE_37C])
    this.mapOfProcessStepAndAction.set(ProcessStep.RESUSPEND_DNA, [Action.INCUBATION_58C])

    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.AMPLIFY_WGA, [Action.INCUBATE_WGA_RT, Action.INCUBATE_WGA_37C]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.PRECIPITATE_DNA, [Action.CENTRIFUGE, Action.MAX_DRYING_TIME]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C, Action.INCUBATE_48C]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.FRAGMENT_DNA, [Action.INCUBATE_37C]);

    this.mapOfActionRuntime.set(Action.INCUBATE_WGA_37C, 180)
    this.mapOfActionRuntime.set(Action.RUN_THERMO_CYCLER, 67)
    this.mapOfActionRuntime.set(Action.INCUBATE_37C, 60)
    this.mapOfActionRuntime.set(Action.CENTRIFUGE, 20)
    this.mapOfActionRuntime.set(Action.MAX_DRYING_TIME, 60)
    this.mapOfActionRuntime.set(Action.INCUBATION_58C, 90)
    this.mapOfActionRuntime.set(Action.INCUBATE_95C, 20)
    this.mapOfActionRuntime.set(Action.INCUBATE_RT, 30)

    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_WGA_RT, 10)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_WGA_37C, 240)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_37C, 30)
    this.mapOfActionRuntimeAxiom384.set(Action.CENTRIFUGE, 40)
    this.mapOfActionRuntimeAxiom384.set(Action.MAX_DRYING_TIME, 30)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_95C, 10)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_48C, 3);

    this.machineProcessStepStatusMap.set(PlateStatus.START_PREPCR, 'WGA_AND_PGX')
    this.machineProcessStepStatusMap.set(PlateStatus.RECOMBINING_STARTED, ProcessStep.RECOMBINE_DNA)
    this.machineProcessStepStatusMap.set(PlateStatus.PRECIPITATION_STARTED, ProcessStep.PRECIPITATE_DNA)
    this.machineProcessStepStatusMap.set(PlateStatus.RESUSPENDING_STARTED, ProcessStep.RESUSPEND_DNA)

    //hardcoding preview comment - to be removed
    this.previewComment = new Comment();

    this.activatedRoute.queryParams.subscribe(params=>{
      var plateID: string = params['plateID']
      if(plateID && plateID.trim()!==''){
        this.plateToSearch = plateID;
        this.searchForPlate()
      }
    });

    if(this.scannedPlateID) {
      this.plateToSearch = this.scannedPlateID;
      this.searchForPlate();
      this.scannedPlateID = null;
    } else {
      // check for processFlow data that's been stored and check if more than one
      // if more than one then show table
      // if one then check if view type is old or new and set accordingly
      this.assignPlateView();
    }
  }

  assignPlateView() {
    let processFlowData: any[] = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    if(processFlowData && processFlowData.length == 1) {
      if(processFlowData[0].axiom384Propel && processFlowData[0].manualPreparation) {
        this.viewType = BeadChipProcessFlows.AXIOM_384;
      } else {
        this.viewType = BeadChipProcessFlows.OLD_FLOW;
      }
      this.plateViewSelectionDone = true;
    } else if(processFlowData && processFlowData.length > 1) {
      this.plateToSearch = '';
      this.plateViewSelectionDone = false;
    } else {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No process flow found', detail: 'No processflow found. Please configure process flow and try again'});
      this.plateViewSelectionDone = false;
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  savePlateStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number) {
    if(!this.multiPlate && PlateStatus.RECOMBINING_STARTED != status) {
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    } else {
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;
      if(stage==ProcessStepStage.start){
        if(PlateStatus.STORED==status)
          this.multiUpdateButtonStyleClass = "otherbutton"
        else
          this.multiUpdateButtonStyleClass = "startButton"
      }else if(stage==ProcessStepStage.end){
        this.multiUpdateButtonStyleClass = "endButton"
      }else{
        this.multiUpdateButtonStyleClass = "VioletButtons"
      }
      if([PlateStatus.START_PREPCR].includes(status))
        this.multiLiquidHandler = this.amplifyLiquidHandler;
      else if(PlateStatus.RECOMBINING_STARTED == status)
        this.multiLiquidHandler = this.recombineLiquidHandler;
      else if(PlateStatus.PRECIPITATION_STARTED == status)
        this.multiLiquidHandler = this.precipitateLiquidHandler;
      else if(PlateStatus.RESUSPENDING_STARTED == status)
        this.multiLiquidHandler = this.resuspendLiquidHandler;
      else
        this.multiLiquidHandler = '';

      this.enteredPlateId ="";
      this.enteredPgxPlateId="";
      this.enteredWgaPlateId="";
      this.resetRecombineEntry();
      this.multiUpdatePlateList =[];
      this.multiPlateUpdateListForRecombine = [];

      this.multiUpdatePlateListSave =[];
      this.multiUpdatePlateInfoList =[];
      this.multiUpdatePlateInfoList1=[];
      this.multiUpdatePGXPlateListSave=[];
      this.multiUpdateWGAPlateListSave=[];
      if(PlateStatus.RECOMBINING_STARTED == status){
        this.showConfirmPlatesPopupForRecombine = true;
        setTimeout(()=>{
          this.findAndHighlightElement("wgaPlateid")
        }, 10)
      }else if(status===PlateStatus.START_PREPCR){
        this.showStartWGAorPGXMultiPlateUpdate = true;
        this.multiUpdatePlateType = "SOURCE"
        setTimeout(()=>{
          this.findAndHighlightElement("source-plate-id")
        }, 10)
      }else{
        if(stepName===ProcessStep.AMPLIFY_PGX || stepName === ProcessStep.STORE_PGX_PLATE){
          this.multiUpdateInputLabel = "Scan PGx Plate"
          this.multiUpdatePlateType = "PGX"
        }
        else{
          this.multiUpdateInputLabel = "Scan WGA Plate"
          this.multiUpdatePlateType = "WGA"
        }
        this.showConfirmPlatesPopup = true;
        setTimeout(()=>{
          this.findAndHighlightElement("popup-plateid")
        }, 10)
      }
    }
  }

  getMultiUpdateDto(){
    let multiPlateUpdate : MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.action = this.multiActionName;
    multiPlateUpdate.plateids = this.multiUpdatePlateListSave;
    multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList;
    if(ProcessStep.RECOMBINE_DNA === this.multiStepName){
      multiPlateUpdate.plateUpdateInfoList = this.multiPlateUpdateListForRecombine;
    }
    multiPlateUpdate.step = this.multiStepName;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.status = this.multiUpdateStatus;
    multiPlateUpdate.actionRunTime =  (this.viewType == BeadChipProcessFlows.AXIOM_384)  ? this.mapOfActionRuntimeAxiom384.get(this.multiActionName) : this.mapOfActionRuntime.get(this.multiActionName);
    return multiPlateUpdate;
  }

  updateStartProcessForMultiplePlates(){
    if(this.validStorageSteps.includes(this.multiStepName) && (this.selectedStorage==undefined || this.selectedStorage == null)){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Not Selected',
        detail: "Please select a storage"
      });
      return;
    }

    if(this.multiStepName==ProcessStep.STORE_PGX_PLATE || this.multiStepName == ProcessStep.SAFE_STOPPING)
      this.multiUpdateStatus = PlateStatus.RECOMBINING_COMPLETED;
    let multiUpdateDto = this.getMultiUpdateDto();

    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        if(this.multiUpdateStatus == PlateStatus.START_PREPCR){
          this.updateMultiPlateUpdateProcessStep(ProcessStep.AMPLIFY_WGA, 0, "")
          this.updateMultiPlateUpdateProcessStep(ProcessStep.AMPLIFY_PGX, 0, "")
        }else{
          this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        }
        this.closeMultiUpdatePopup();
        this.multiPlate = true;
        if([PlateStatus.START_PREPCR, PlateStatus.RECOMBINING_STARTED, PlateStatus.PRECIPITATION_STARTED, PlateStatus.RESUSPENDING_STARTED].includes(multiUpdateDto.status))
          this.updateMachine(multiUpdateDto.liquidHandler, multiUpdateDto.status, this.multiUpdateSelectedWorkFlow);
      },
      error:(error) =>{
        if(this.multiStepName==ProcessStep.SAFE_STOPPING)
          this.multiUpdateStatus = PlateStatus.STORED;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
    if(this.validStorageSteps.includes(this.multiStepName)){
      let plateData = {};
      plateData['labid'] = this.selectedLabId;
      plateData['plateids'] = this.multiUpdatePlateList;
      plateData['storageName'] = this.selectedStorage['storageName'];
      this._maStorageService.addMultiplePlatesToStorage(plateData).subscribe({
        next:(result) => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Plates Added Successfully',
            detail: multiUpdateDto.plateids+" added successfully to storage "+this.selectedStorage['storageName']
          });
          this.selectedStorage = null
        },
        error:(error) => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Plates Not Added',
            detail: error.error
          });
          this.selectedStorage = null
        }
      });
    }
    else if(this.validRestorationSteps.includes(this.multiStepName)){
      let plateData = {};
      plateData['labid'] = this.selectedLabId;
      if([ProcessStep.FRAGMENT_DNA,ProcessStep.PRECIPITATE_DNA,ProcessStep.RESUSPEND_DNA].includes(this.multiStepName))
        plateData['plateids'] = this.multiUpdatePlateList;
      else{
        let plateidlist = [];
        this.multiUpdatePlateInfoList.forEach(value => {
          plateidlist.push(value.plateID);
        });
        plateData['plateids'] = plateidlist;
      }
      this._maStorageService.removeMultiplePlatesFromStorage(plateData).subscribe({
        next:(_result) => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Plate Removed Successfully',
            detail: multiUpdateDto.plateids+" removed successfully to storage "+this.selectedStorage['storageName']
          });
        },
        error:(error) => {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Plates Not Removed',
            detail: error.error
          });
        }
      });
    }
  }

  updateEndProcessForMultiplePlates(){
    let multiUpdateDto = this.getMultiUpdateDto();
    let updatedMultiUpdateDto : MultiPlateUpdate = new MultiPlateUpdate();

    updatedMultiUpdateDto.action = multiUpdateDto.action;
    updatedMultiUpdateDto.actionRunTime = multiUpdateDto.actionRunTime;
    updatedMultiUpdateDto.labid = multiUpdateDto.labid;
    updatedMultiUpdateDto.plateUpdateInfoList = multiUpdateDto.plateUpdateInfoList;
    updatedMultiUpdateDto.puid = multiUpdateDto.puid;
    updatedMultiUpdateDto.status = multiUpdateDto.status;
    updatedMultiUpdateDto.step = multiUpdateDto.step;

    if (multiUpdateDto.step === ProcessStep.AMPLIFY_WGA || multiUpdateDto.step === ProcessStep.AMPLIFY_PGX){
      updatedMultiUpdateDto.status = PlateStatus.PREPCR_COMPLETED;
      let plateids1 = [];
      let plateids2 = [];
      multiUpdateDto.plateids.forEach((plateid, index) => {
          let stepsMap = this.multiPlateStepsMapList[index];
          let endTimeStamp, endPUID;
          if(multiUpdateDto.step == ProcessStep.AMPLIFY_WGA){
            endTimeStamp = stepsMap.get(ProcessStep.AMPLIFY_PGX).endTimeStamp;
            endPUID = stepsMap.get(ProcessStep.AMPLIFY_PGX).endPUID;
          }
          else{
            endTimeStamp = stepsMap.get(ProcessStep.AMPLIFY_WGA).endTimeStamp;
            endPUID = stepsMap.get(ProcessStep.AMPLIFY_WGA).endPUID;
          }
          if(endTimeStamp === null || endTimeStamp === '' || endTimeStamp === undefined || endPUID === null || endPUID === '' || endPUID === undefined){
            plateids1.push(plateid);
          }
          else{
            plateids2.push(plateid);
          }
      });
      multiUpdateDto.plateids = plateids1;
      updatedMultiUpdateDto.plateids = plateids2;
    }
    else{
      updatedMultiUpdateDto.plateids = [];
    }


    if (multiUpdateDto.plateids.length !== 0 && multiUpdateDto.plateids !== undefined && multiUpdateDto.plateids !== null){
      this.platePreparationService.updateEndProcessForMultiplePlates(multiUpdateDto).subscribe({
        next:(result) =>{

          if (updatedMultiUpdateDto.plateids.length !== 0 && updatedMultiUpdateDto.plateids !== undefined && updatedMultiUpdateDto.plateids !== null){
            this.platePreparationService.updateEndProcessForMultiplePlates(updatedMultiUpdateDto).subscribe({
              next:(updatedResult) =>{
                this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: `Plates Updated` });
                this.lastUpdatedStatus = updatedMultiUpdateDto.status;
                this.updateLastUpdatedPlates();
              },
              error:(error) =>{
                this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
              }
            })
          }
          else{
            this.lastUpdatedStatus = updatedMultiUpdateDto.status;
            this.updateLastUpdatedPlates();
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: `Plates Updated` });
          }
          this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
          this.closeMultiUpdatePopup();
          this.multiPlate = true;
        },
        error:(error) =>{
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      })
    }
    else{
      if (updatedMultiUpdateDto.plateids.length !== 0 && updatedMultiUpdateDto.plateids !== undefined && updatedMultiUpdateDto.plateids !== null){
        this.platePreparationService.updateEndProcessForMultiplePlates(updatedMultiUpdateDto).subscribe({
          next:(updatedResult) =>{
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: updatedResult });
            this.lastUpdatedStatus = updatedMultiUpdateDto.status;
            this.updateLastUpdatedPlates();
            this.closeMultiUpdatePopup();
            this.multiPlate = true;
          },
          error:(error) =>{
            this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
          }
        })
      }
    }
  }

  updateStartActionProcessForMultiplePlates(){
    let multiUpdateDto = this.getMultiUpdateDto();
    this.platePreparationService.updateStartActionProcessForMultiplePlates(multiUpdateDto).subscribe({
      next:(result) =>{
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiPlate = true;
      },
      error:(error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  updateMultiPlates(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch(this.multiStage){
      case ProcessStepStage.start:
        this.updateStartProcessForMultiplePlates()
        break;
      case ProcessStepStage.end:
        this.updateEndProcessForMultiplePlates();
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessForMultiplePlates();
        break;
    }
  }

  resetLastUpdatedPlates(){
    this.lastUpdatedPlates1 = [];
    this.lastUpdatedPlates2 = [];
    this.lastUpdatedPlates3 = [];
    this.chemicalsPlateids = [];
  }

  updateLastUpdatedPlates(){
    this.lastUpdatedPlates1 = [];
    this.lastUpdatedPlates2 = [];
    this.lastUpdatedPlates3 = [];
    this.chemicalsPlateids = [];
    if(this.showStartWGAorPGXMultiPlateUpdate){
      for(var i=0;i<30;i++){
        let updatedPlate = { plateId : this.multiUpdatePlateInfoList.length>i ? this.multiUpdatePlateInfoList[i].plateID : '' }
        if(i<10){
          this.lastUpdatedPlates1.push(updatedPlate)
        }else if(i<20){
          this.lastUpdatedPlates2.push(updatedPlate)
        }else{
          this.lastUpdatedPlates3.push(updatedPlate)
        }

        if(this.multiUpdatePlateInfoList.length>i){
          this.chemicalsPlateids.push(this.multiUpdatePlateInfoList[i].plateID);
        }
      }
    }else if(this.showConfirmPlatesPopupForRecombine){
      for(var i=0;i<30;i++){
        let updatedPlate = { plateId : this.multiPlateUpdateListForRecombine.length>i ? this.multiPlateUpdateListForRecombine[i].wgaPlateID : '' }
        if(i<10){
          this.lastUpdatedPlates1.push(updatedPlate)
        }else if(i<20){
          this.lastUpdatedPlates2.push(updatedPlate)
        }else{
          this.lastUpdatedPlates3.push(updatedPlate)
        }

        if(this.multiPlateUpdateListForRecombine.length>i){
          this.chemicalsPlateids.push(this.multiPlateUpdateListForRecombine[i].plateID);
        }
      }
    }else{
      for(var i=0;i<30;i++){
        let updatedPlate = { plateId : this.multiUpdatePlateList.length>i ? this.multiUpdatePlateList[i] : '' }
        if(i<10){
          this.lastUpdatedPlates1.push(updatedPlate)
        }else if(i<20){
          this.lastUpdatedPlates2.push(updatedPlate)
        }else{
          this.lastUpdatedPlates3.push(updatedPlate)
        }

        if(this.multiUpdatePlateList.length>i){
          this.chemicalsPlateids.push(this.multiUpdatePlateListSave[i]);
        }
      }
    }
  }

  closeMultiUpdatePopup() {
    this.showConfirmPlatesPopup = false;
    this.showConfirmPlatesPopupForRecombine = false;
    this.multiUpdatePlateList = [];
    this.multiPlateUpdateListForRecombine =[];
    this.enteredPGXPlateId = "";
    this.enteredWGAPlateId = ""
    this.enteredPlateId = "";
    this.showStartWGAorPGXMultiPlateUpdate = false;
    this.multiUpdatePlateListSave = [];
    this.multiUpdatePGXPlateListSave=[];
    this.multiUpdateWGAPlateListSave=[];
    this.enteredPlateId ="";
    this.enteredWgaPlateId = "";
    this.enteredPgxPlateId = "";
    this.multiPlateStepsMap.clear();
    this.multiPlateStepsMapList = [];
    this.selectedPlateStepsMap.clear();
    this.tableSelectedRow = null;
    this.selectedPlate = new Plate();
    this.multiUpdateButtonStyleClass = "";
  }

  startWGAandPGX(status:string){
    this.multiStage = 0;
    this.multiUpdateStatus = status;
    this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;
    this.multiUpdateButtonStyleClass = "startButton";
    this.enteredWgaPlateId ="";
    this.enteredPgxPlateId ="";
    this.multiUpdatePlateList =[];
    this.multiUpdatePlateListSave =[];
    this.multiUpdatePGXPlateListSave=[];
    this.multiUpdateWGAPlateListSave=[];
    this.multiUpdatePlateInfoList1=[];
    this.multiUpdatePlateInfoList =[];
    this.showStartWGAorPGXMultiPlateUpdate = true;
    this.enteredPlateId =this.selectedPlate.plateID;
    this.multiUpdatePlateType = "SOURCE";
    this.multiStepName = ProcessStep.AMPLIFY_WGA;
    this.multiLiquidHandler = this.amplifyLiquidHandler;
    setTimeout(()=>{
      this.findAndHighlightElement("wga-plate-id")
    }, 1000)
  }

  startWGA(status: string){
    if(!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeWGA(status: string){
    if(!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.end, "")){
      return;
    }
    if(PlateStatus.PGX_COMPLETED==this.selectedPlate.status){
      this.selectedPlate.status = PlateStatus.PREPCR_COMPLETED;
    }else{
      this.selectedPlate.status = status;
    }
    this.showWarningMessage(ProcessStep.AMPLIFY_WGA, Action.INCUBATE_WGA_37C)
    this.updatePlate("","",ProcessStep.AMPLIFY_WGA);
  }

  startRecombining(status: string){
    if(!this.updateProcessStep(ProcessStep.RECOMBINE_DNA, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(this.recombineLiquidHandler, status);
  }

  completeRecombining(status: string){
    if(!this.updateProcessStep(ProcessStep.RECOMBINE_DNA, ProcessStepStage.end, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  storePgxPlate(status:string){
    let currentSelectedStorage = this.selectedStorage || this.fetchSingleStorageBasedOnProcessSteps(ProcessStep.STORE_PGX_PLATE)
    if(currentSelectedStorage == undefined || currentSelectedStorage == null){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Not Selected',
        detail: "Please select a storage"
      });
      return;
    }
    this.updateProcessStep(ProcessStep.STORE_PGX_PLATE, ProcessStepStage.start,"")
    this.updatePlate();
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.selectedPlate.pgxPlateID).subscribe({
      next:(result) => {
        if(result.storageName != undefined){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Plate Already Stored',
            detail: this.selectedPlate.pgxPlateID+" already present in "+result.storageName
          });
          return;
        }
      },
      error:(_error) =>{
        let plateData = {};
        plateData['labid'] = this.selectedLabId;
        plateData['plateid'] = this.selectedPlate.pgxPlateID;
        plateData['storageName'] = currentSelectedStorage["storageName"]
        this._maStorageService.addPlateToStorage(plateData).subscribe({
          next:(_result) => {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.pgxPlateID+" added successfully to storage "+this.selectedStorage['storageName']
            });
            this.selectedStorage = null
          },
          error:(error) => {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });
            this.selectedStorage = null
          }
        });
      }
    })
  }

  fragmentDnaSafeStopping(status: string){
    this.storeWgaPlateBasedOnStep(ProcessStep.FRAGMENT_SAFE_STOPPING);
  }

  precipitateDnaSafeStopping(status: string){
    this.storeWgaPlateBasedOnStep(ProcessStep.PRECIPITATE_SAFE_STOPPING);
  }

  resuspendDnaSafeStopping(status : string){
    this.storeWgaPlateBasedOnStep(ProcessStep.RESUSPEND_SAFE_STOPPING);
  }

  storeWgaPlateBasedOnStep(step: string){
    let currentSelectedStorage = this.selectedStorage || this.fetchSingleStorageBasedOnProcessSteps(step)
    if(currentSelectedStorage == undefined || currentSelectedStorage == null){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Not Selected',
        detail: "Please select a storage"
      });
      return;
    }
    this.updateProcessStep(step, ProcessStepStage.start,"")
    this.updatePlate();
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.selectedPlate.lastUpdatedPlateID).subscribe({
      next:(result) => {
        if(result.storageName != undefined){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Plate Already Stored',
            detail: this.selectedPlate.lastUpdatedPlateID+" already present in "+result.storageName
          });
          return;
        }
      },
      error:(error) =>{
        let plateData = {};
        plateData['labid'] = this.selectedLabId;
        plateData['plateid'] = this.selectedPlate.lastUpdatedPlateID;
        plateData['storageName'] = currentSelectedStorage["storageName"]
        this._maStorageService.addPlateToStorage(plateData).subscribe({
          next:(result) => {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.lastUpdatedPlateID+" added successfully to storage "+currentSelectedStorage["storageName"]
            });
            this.selectedStorage = null
          },
          error:(error) => {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });
          }
        });
      }
    })
  }

  startPrecipitation(status: string){
    if(!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.start, "", this.precipitateLiquidHandler)){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(this.precipitateLiquidHandler, status);
  }

  completePrecipitation(status: string){
    if(!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.end, "")){
      return;
    }
    this.showWarningMessage(ProcessStep.PRECIPITATE_DNA, Action.MAX_DRYING_TIME)
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startDenaturation(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeDenaturation(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.end, "")){
      return;
    }
    if(this.viewType == BeadChipProcessFlows.OLD_FLOW) {
      this.showWarningMessage(ProcessStep.DENATURATE_DNA, Action.INCUBATE_RT)
    } else {
      this.showWarningMessage(ProcessStep.DENATURATE_DNA, Action.INCUBATE_48C)
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startPGX(status: string){
    if(!this.updateProcessStep(ProcessStep.AMPLIFY_PGX, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completePGX(status: string){

    if(!this.updateProcessStep(ProcessStep.AMPLIFY_PGX, ProcessStepStage.end, "")){
      return;
    }
    if(PlateStatus.WGA_COMPLETED==this.selectedPlate.status){
      this.selectedPlate.status = PlateStatus.PREPCR_COMPLETED;
    }else{
      this.selectedPlate.status = status;
    }
    this.showWarningMessage(ProcessStep.AMPLIFY_PGX, Action.RUN_THERMO_CYCLER)
    this.updatePlate("","",ProcessStep.AMPLIFY_PGX);
  }

  startFragmentation(status: string){
    if(!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.start, "")){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
    let plateData = {};
    plateData['labid'] = this.selectedLabId;
    plateData['plateid'] = this.selectedPlate.wgaPlateID;
    this._maStorageService.removePlateFromStorage(plateData).subscribe({
      next:(result) => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate Removed Successfully',
          detail: this.selectedPlate.plateID+" removed successfully to storage "+this.selectedStorage['storageName']
        });
      },
      error:(error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plates Not Removed',
          detail: error.error
        });
      }
    });
  }

  completeFragmentation(status: string){
    if(!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.end, "")){
      return;
    }
  this.showWarningMessage( ProcessStep.FRAGMENT_DNA, Action.INCUBATE_37C)
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startResuspending(status: string){
    if(!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.start, "",this.resuspendLiquidHandler)){
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(this.resuspendLiquidHandler, status);
  }

  completeResuspending(status: string){
    if(!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.end, "")){
      return;
    }

    if(this.viewType == BeadChipProcessFlows.OLD_FLOW) {
      this.showWarningMessage(ProcessStep.RESUSPEND_DNA, Action.INCUBATION_58C)
    }

    this.selectedPlate.status = status;
    this.updatePlate();
  }

  actionIncubateWGA37c(status: string){
    if(!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.action, status)){
        return;
      }
    this.updatePlate("","",ProcessStep.AMPLIFY_WGA);
  }

  actionCentrifuge(status: string){
    if(!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionMaxDryingTime(status: string){
    if(!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.showWarningMessage(ProcessStep.PRECIPITATE_DNA, Action.CENTRIFUGE)
    this.updatePlate();
  }

  actionIncubate95c(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubateRT(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.showWarningMessage(ProcessStep.DENATURATE_DNA, Action.INCUBATE_95C)
    this.updatePlate();
  }

  actionIncubate48C(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.showWarningMessage(ProcessStep.DENATURATE_DNA, Action.INCUBATE_95C)
    this.updatePlate();
  }

  actionRunThermoCycler(status: string){
    if(!this.updateProcessStep(ProcessStep.AMPLIFY_PGX, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate("","",ProcessStep.AMPLIFY_PGX);
  }

  actionIncubate37c(status: string){
    if(!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubation58c(status: string){
    if(!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.action, status)){
      return;
    }
    this.updatePlate();
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean{
    if(!this.multiPlate){
      if((!this.selectedPlateStepsMap || this.selectedPlateStepsMap==null || this.selectedPlateStepsMap.size < 1)){
        return true;
      }
      switch(stage){
        case ProcessStepStage.start:
          return this.disableProcessStepStart(stepName,this.selectedPlateStepsMap);
        case ProcessStepStage.end:
          return this.disableProcessStepEnd(stepName,this.selectedPlateStepsMap);
        case ProcessStepStage.action:
          return this.disableProcessStepAction(stepName, actionName, actionPos,this.selectedPlateStepsMap);
        default:
          return true;
      }
    }
    return false;
  }

  eligiblePlate(stage: number, stepName: string, actionName: string, actionPos: number){
    if((!this.multiPlateStepsMap || this.multiPlateStepsMap==null || this.multiPlateStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiPlateStepsMap);
      default:
        return true;
    }
   }

  focuspgxPlateID(): any {
    this.enteredPGXPlateId ="";
    document.getElementById("pgxPlateID").focus();
  }

  focuswgaPlateID(): any {
    document.getElementById("wgaPlateid").focus();
  }

  checkforPGXPlate(){
    this.pgxPlateIDPlaceHolder = "Scan PGX Plate";
    if(this.enteredWGAPlateId && this.enteredWGAPlateId =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId,this.enteredWGAPlateId,'WGA').subscribe({
      next:(result)=>{
        this.fetchedPlate = result;
        if( this.enteredWGAPlateId && this.multiUpdatePlateListSave && this.multiUpdatePlateListSave.includes(this.fetchedPlate.plateID)) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
          this.resetRecombineEntry();
          this.focuswgaPlateID();
          return;
        }
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);
        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a different Plate.' });
          this.resetRecombineEntry();
          return;
        }
        this.pgxPlateIDPlaceHolder = this.fetchedPlate.pgxPlateID;
        this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
        this.focuspgxPlateID();
      },
      error:(_error)=>{
        this.enteredWGAPlateId ="";
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredWGAPlateId
        })
      }
    })
  }
  resetRecombineEntry(){
    this.enteredWGAPlateId ="";
    this.enteredPGXPlateId ="";
    this.pgxPlateIDPlaceHolder = "Scan PGX Plate";
  }
  checkPGXPlate(){
    if((this.enteredPGXPlateId && this.enteredPGXPlateId =="")||(this.enteredWGAPlateId && this.enteredWGAPlateId =="")) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    if(this.enteredPGXPlateId != this.fetchedPlate.pgxPlateID){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not Matching', detail: 'Please scan a WGA and PGX Plate of same Source Plate' });
      this.enteredPGXPlateId="";
      return;
    }
    this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
    let plate : PlateUpdateInfo = new PlateUpdateInfo();
    plate.wgaPlateID = this.enteredWGAPlateId;
    plate.pgxPlateID = this.enteredPGXPlateId;
    plate.plateID = this.fetchedPlate.plateID;
    this.multiPlateUpdateListForRecombine.unshift(plate);
    this.resetRecombineEntry();
    this._messagesService.addSuccessMessage({
      severity: 'success', summary: 'Plate '+this.fetchedPlate.plateID,
      detail: 'Added to List'
    })
    this.focuswgaPlateID();
   }

   deleteItem(index){
    this.multiUpdatePlateListSave.splice(index,1);
    this.multiPlateUpdateListForRecombine.splice(index,1);
    this.findAndHighlightElement('wgaPlateid');
  }

  checkPlate(){
    if(this.enteredPlateId && this.multiUpdatePlateList && this.multiUpdatePlateList.includes(this.enteredPlateId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(this.enteredPlateId && this.multiUpdatePlateList && this.multiUpdatePlateList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(!this.enteredPlateId || this.enteredPlateId.trim() =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId,this.enteredPlateId,this.multiUpdatePlateType).subscribe({
      next:(result)=>{
        this.fetchedPlate = result;
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);
        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a different Plate.' });
          this.enteredPlateId = "";
        } else{
          if(this.multiUpdateStatus!==PlateStatus.START_PREPCR){
            this.multiUpdatePlateList.unshift(this.enteredPlateId);
            this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
            this.enteredPlateId ="";
          }else{
            this.findAndHighlightElement("wga-plate-id");
          }
          this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;
        }
      },
      error:(_error)=>{
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredPlateId
        })
        this.enteredPlateId = "";
      }
    })
  }

  deleteValue(index){
    this.multiUpdatePlateList.splice(index,1);
    this.multiUpdatePlateListSave.splice(index,1);
    this.multiPlateStepsMapList.splice(index,1);
    this.findAndHighlightElement('popup-plateid');
  }

  checkWgaPlateID(){
    if(!this.enteredWgaPlateId || this.enteredWgaPlateId==='' || this.enteredWgaPlateId.trim()===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Empty',
        detail: 'WGA Plate ID Cannot be empty'
      })
      return;
    }

    if(this.enteredWgaPlateId === this.enteredPlateId){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Duplicate WGA Plate',
        detail: 'WGA Plate ID Cannot be same as Plate ID'
      });
      this.enteredWgaPlateId = "";
      return;
    }
    if(!this.enteredWgaPlateId.endsWith("-WGA")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Failed to update WGA Plate',
        detail:'WGA PlateID should end with <strong>-WGA</strong>'
      })
      this.enteredWgaPlateId = "";
      return;
    }

    if (this.multiUpdatePlateInfoList.length > 0) {
      this.multiUpdatePlateInfoList.forEach(e => {
        this.multiUpdateWGAPlateListSave.push(e.wgaPlateID);
      });
    }

    if (this.enteredWgaPlateId && this.multiUpdateWGAPlateListSave && this.multiUpdateWGAPlateListSave.includes(this.enteredWgaPlateId) ) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate WGA Plate', detail: 'WGAPlate already Scanned.' });
      this.enteredWgaPlateId = "";
      this.findAndHighlightElement("wga-plate-id");
      return;
    }

    this.platePreparationService.checkDuplicatePlateId(this.selectedLabId, this.enteredWgaPlateId, 'WGA').subscribe({
      next:(result) => {
        if(result['duplicate']){
          this._messagesService.addWarningMessage({severity: 'warn', summary: 'Duplicate WGA Plate', detail: result['message']});
          this.enteredWgaPlateId = '';
          this.findAndHighlightElement("wga-plate-id");
          return;
        }
        else{
          let plateUpdateInfo1 = new PlateUpdateInfo();
          plateUpdateInfo1.wgaPlateID = this.enteredWgaPlateId;
          this.multiUpdatePlateInfoList1.push(plateUpdateInfo1);
          this.findAndHighlightElement("pgx-plate-id");
        }
      },error: (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to check for duplicate id',
          detail: error.error
        });
        return true;
      }
    });
  }

  checkPgxPlateID() {
    if (!this.enteredPgxPlateId || this.enteredPgxPlateId === '' || this.enteredPgxPlateId.trim() === '') {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Empty',
        detail: 'PGX Plate ID Cannot be empty'
      })
      return;
    }

    if (this.enteredPgxPlateId === this.enteredPlateId) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Duplicate PGX Plate',
        detail: 'PGX Plate ID Cannot be same as Plate ID'
      });
      this.enteredPgxPlateId = "";
      return;
    }
    if (!this.enteredPgxPlateId.endsWith("-PGX")) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Failed to update PGX Plate',
        detail: 'PGX PlateID should end with <strong>-PGX</strong>'
      })
      this.enteredPgxPlateId = "";
      return;
    }

    if (this.multiUpdatePlateInfoList.length > 0) {
      this.multiUpdatePlateInfoList.forEach(e => {
        this.multiUpdatePGXPlateListSave.push(e.pgxPlateID);
      });
    }
    if (this.enteredPgxPlateId && this.multiUpdatePGXPlateListSave && this.multiUpdatePGXPlateListSave.includes(this.enteredPgxPlateId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate PGX Plate', detail: 'PGXPlate already Scanned.' });
      this.enteredPgxPlateId = "";
      this.findAndHighlightElement("pgx-plate-id");
      return;
    }

    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredPlateId, this.multiUpdatePlateType).subscribe({
      next: (result) => {
        this.fetchedPlate = result;
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);
        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if (notEligible) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a different Plate.' });
          this.enteredPlateId = "";
          this.enteredWgaPlateId = "";
        } else {
          if (this.multiUpdateStatus !== PlateStatus.START_PREPCR) {
            this.multiUpdatePlateList.unshift(this.enteredPlateId);
            this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
            this.enteredPlateId = "";
          }
        }
        if (this.enteredPlateId && this.multiUpdatePlateList && this.multiUpdatePlateList.includes(this.enteredPlateId)) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
          this.enteredPlateId = "";
          this.enteredWgaPlateId = "";
          this.enteredPgxPlateId = "";
          return;
        }
        if (this.multiUpdatePlateInfoList.length > 0) {
          this.multiUpdatePlateInfoList.forEach(e => {
            this.multiUpdateWGAPlateListSave.push(e.wgaPlateID);
          });
        }
        if (this.enteredWgaPlateId && this.multiUpdateWGAPlateListSave && this.multiUpdateWGAPlateListSave.includes(this.enteredWgaPlateId)) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate WGA Plate', detail: 'WGAPlate already Scanned.' });
          this.enteredWgaPlateId = "";
          this.enteredPgxPlateId = "";
          this.findAndHighlightElement("wga-plate-id");
          return;
        }

        this.platePreparationService.checkDuplicatePlateId(this.selectedLabId, this.enteredWgaPlateId, 'WGA').subscribe({
          next: (result) => {
            if (result['duplicate']) {
              this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate WGA Plate', detail: result['message'] });
              this.enteredWgaPlateId = '';
              this.findAndHighlightElement("wga-plate-id");
              return;
            }
            else {

              this.platePreparationService.checkDuplicatePlateId(this.selectedLabId, this.enteredPgxPlateId, 'PGX').subscribe({
                next: (result) => {
                  if (result['duplicate']) {
                    this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate PGX Plate', detail: result['message'] });
                    this.enteredPgxPlateId = '';
                    this.findAndHighlightElement("pgx-plate-id");
                    return;
                  }
                  else {
                    let plateUpdateInfo = new PlateUpdateInfo();
                    plateUpdateInfo.plateID = this.enteredPlateId;
                    plateUpdateInfo.wgaPlateID = this.enteredWgaPlateId;
                    plateUpdateInfo.pgxPlateID = this.enteredPgxPlateId;
                    this.multiUpdatePlateListSave.unshift(this.enteredPlateId)
                    this.multiUpdatePlateList.unshift(this.enteredPlateId)
                    this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
                    this.enteredPlateId = "";
                    this.enteredWgaPlateId = "";
                    this.enteredPgxPlateId = "";
                    this.findAndHighlightElement("source-plate-id")
                  }
                }, error: (error) => {
                  this.showError(error)
                  return true;
                }
              });

            }
          }, error: (error) => {
            this.showError(error)
            return true;
          }
        });

      },
      error: (_error) => {
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredPlateId
        })
        this.enteredPlateId = "";
        this.enteredWgaPlateId = "";
        this.enteredPgxPlateId = "";
      }
    })
  }

  deleteRow(index){
    this.multiUpdatePlateListSave.splice(index,1);
    this.multiUpdatePlateList.splice(index,1);
    this.multiUpdatePlateInfoList.splice(index, 1);
    this.findAndHighlightElement('source-plate-id');
  }

  disableProcessStepStart(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {

    let dependentSteps: string[] = (this.viewType != BeadChipProcessFlows.AXIOM_384) ? this.mapOfProcessStepsFlow.get(stepName) : this.mapOfProcessStepsFlowAxiom384.get(stepName);
    let disable: boolean = true;
    for(let step of dependentSteps){
      if(step==ProcessStep.RECEIVE_PLATE){
        disable = !selectedPlateStepsMap.has(step) || this.isEmptyString(selectedPlateStepsMap.get(step).startPUID) || this.isEmptyDate(selectedPlateStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedPlateStepsMap.has(stepName)){
      disable = true;
    }
    return disable;
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedPlateStepsMap:Map<string, Step>): boolean{
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = (this.viewType == BeadChipProcessFlows.AXIOM_384) ? this.mapOfProcessStepAndActionAxiom384.get(stepName) : this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(actionPos==0){
      disable = currentProcessStep.actionMap.has(actionName);
    }else{
      if(!currentProcessStep.actionMap.has(actionName) && currentProcessStep.actionMap.has(processStepActions[0])){
        disable = false;
      }
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = (this.viewType == BeadChipProcessFlows.AXIOM_384) ? this.mapOfProcessStepAndActionAxiom384.get(stepName) : this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(processStepActions && processStepActions.length>1){
      let previousAction = processStepActions[1];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else if(processStepActions && processStepActions.length>0){
      let previousAction = processStepActions[0];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else{
      disable = false;
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true
      return disable
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true;
    }
    return disable;
  }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  getAllActiveWorkFlowList() {
    this.blocked = true;
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe({
      next: results => {
        if (results && results.data) {
          this.workFlowData = results.data;
          this.workFlowList = [];
          this.workFlowData.forEach(e => {
            this.workFlowList.push({ label: e.workFlowName, value: e.workFlowName });
          });
        }
        this.blocked = false;
      },
      error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    });

  }

  onApplyFilter(){
    let queryStatusList = this.selectedStatuses.join(',');
    this.getProcessFlowListFromProtocolList();
    let queryProcessFlowList = this.selectedProcessFlowList.join(',');
    this.fetchReceivedPlates(queryStatusList, queryProcessFlowList);
  }

  resetAllFilter(){
    this.selectedStatuses = [];
    this.selectedProtocolList = []
    this.selectedProcessFlowList = [];
    this.fromDate = undefined;
    this.fetchReceivedPlates();
  }

  getProcessFlowListFromProtocolList(){
    this.selectedProcessFlowList = [];
    this.processFlows.forEach( processFlow => {
      for(let i=0; i<this.selectedProtocolList.length; i++){
        if(processFlow[this.selectedProtocolList[i]]){
          this.selectedProcessFlowList.push(processFlow.processFlowName)
          break;
        }
      }
    })
  }

  fetchPlate(event) {
    this.beadChipDetails = new Plate()
    this.plateBtn='enabeled';
    this.resetLastUpdatedPlates()
    this.searchForPlateAction(event.data.plateID);
  }

  removePlateSelection(){
    this.beadChipDetails = new Plate()
    this.multiPlate = true;
    this.selectedPlateStepsMap.clear();
    this.multiPlateStepsMap.clear();
    this.multiPlateStepsMapList = [];
    this.selectedPlate = new Plate();
    this.clearLiquidHandlerValues();
  }


  workflowSelection(){
    this.isVisible=false;
    this.blocked = true;
    this.platePreparationService.fetchPlate(this.plateToSearch,this.selectedLabId).subscribe({
      next:(result) => {
        this.blocked = false;
        this.selectPlateView(result.workFlow, result.processFlowName, result.beadChips);
      },error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate workflow',
          detail: error.error
        })
      }
    })
  }


  searchForPlateAction(plateID: string){
    this.isVisible=false;
    this.blocked = true;
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next:(result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.workFlowBeadchip = this.selectedPlate.workFlow
        this.multiPlate = false;
        this.aliquotPlateID = this.selectedPlate.aliquotPlateID;
        if(PlateStatus.STORED == this.selectedPlate.status){
          this.fetchPlateStoragaName(this.selectedPlate.plateID);
        }
        if(PlateStatus.RECOMBINING_COMPLETED == this.selectedPlate.status){
          this.fetchPlateStoragaName(this.selectedPlate.wgaPlateID);
        }
        if(this.selectedPlate.storagePlate){
          this.fetchPlateStoragaName(this.selectedPlate.lastUpdatedPlateID)
        }
        this.selectPlateView(this.selectedPlate.workFlow, this.selectedPlate.processFlowName, this.selectedPlate.beadChips);
        if(PlateStatus.PLATE_REDO == this.selectedPlate.status){
          this._messagesService.addWarningMessage({
            severity:'warn', summary:"Cannot process the current plate!!"
          })
          return;
        }
        this.prepareProcessStepsMap();
      },error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        })
      }
    })
  }

  fetchPlateStoragaName(plateID: string){
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId, plateID).subscribe({
      next:result => {
        this.blocked = false
        this.selectedPlate.storage = result["storageName"]
      },
      error:error => {
        this.blocked = false
        console.log(error)
      }
    });
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'Plate';
    }else {
      return 'View Plate';
    }
  }

  tableVisible(){
    if(this.flag){
      this.plateMap = new Map();
      this.beadchipSamplesMap = new Map();
      this.platePreparationService.fetchPlateByIDandLab(this.selectedLabId, this.selectedPlate.plateID).subscribe({
        next:(result) => {
          if(result && result.samples){
          this.selectedPlate.samples = result.samples;
          if(this.selectedPlate.beadChips && this.selectedPlate.beadChips.length>0 && this.viewType==BeadChipProcessFlows.OLD_FLOW){
            this.beadchipSamplesMap.set(this.selectedPlate.beadChips[0].beadChipID, new Map())
            this.beadchipSamplesMap.set(this.selectedPlate.beadChips[1].beadChipID, new Map())
          }
          this.selectedPlate.samples.forEach(element => {
            this.typeOfView = 'PlateView';
            this.plateMap.set(element.position, element);
            if(this.beadchipSamplesMap.has(element.beadChipID)){
              this.beadchipSamplesMap.get(element.beadChipID).set(element.beadChipPosition, element);
            }
          });
        }
        },error: (error) => {
          this.showError(error);
        }
      })
      this.isVisible=true;
      this.flag=false;
    }else{
      this.isVisible=false;
      this.flag=true;
    }
  }

  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  getBeadchipSampleAt(row: number, col: number, beadchipSamplesMap: Map<string, Map<string, Sample>>, beadchipPosition: number){
    let noSample = new Sample();
    noSample.sampleID='';
    let beadchipWellPosition : string = row.toString() + col.toString();
    let beadchipID = this.getBeadchipAt(beadchipPosition);
    if(beadchipSamplesMap.has(beadchipID)){
      return beadchipSamplesMap.get(beadchipID).has(beadchipWellPosition) ? beadchipSamplesMap.get(beadchipID).get(beadchipWellPosition) : noSample;
    }else{
      return noSample;
    }
  }

  getBeadchipAt(beadchipPosition){
    return (this.selectedPlate.beadChips && this.selectedPlate.beadChips.length>0) ? this.selectedPlate.beadChips[beadchipPosition].beadChipID : '';
  }

  /**
   * Get samples at given row col value for the plate view
   * @param row
   * @param col
   */
  getSampleAt(row: number, col: number, mapOfBatch: Map<string, Sample>) {
    let positionString = this.getRowColStringFromPos(row, col);
    if (mapOfBatch.has(positionString)) {
      return mapOfBatch.get(positionString);
    }
    let sample = new Sample();
    sample.sampleID='';
    return sample;
  }


  updatePlate(liquidHandler: string = "", status: string = "",lastUpdatedStep:string = "") {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId,lastUpdatedStep).subscribe({
      next: (_result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID+' has been updated successfully with requested status'
        })
        let processStepLength = this.selectedPlate.processSteps.length;
        if(!this.selectedPlate.processSteps[processStepLength-1].step.includes("STOPPING")){
          this.removeWgaPlateFromStorage(this.selectedPlate.lastUpdatedPlateID)
        }
        this.searchForPlateAction(this.selectedPlate.plateID);
        if(liquidHandler != "" && status != "")
          this.updateMachine(liquidHandler, status, this.selectedPlate.workFlow);
        liquidHandler = "";
        status = "";
      },
      error : (error) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  removeWgaPlateFromStorage(wgaPlateID: string = ""){
    let plateData = {};
    plateData['labid'] = this.selectedLabId;
    plateData['plateid'] = wgaPlateID

    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,wgaPlateID).subscribe({
      next:_result => {
        this.blocked = false
        this._maStorageService.removePlateFromStorage(plateData).subscribe({
          next:_result => {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Removed Successfully',
              detail: wgaPlateID+" removed successfully to storage "+this.selectedStorage['storageName']
            });
          },
          error:(error) => {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plates Not Removed',
              detail: error.error
            });
          }
        });
        return
      },
      error:_error => {
        this.blocked = false
        return
      }
    })
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();
    if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
      return;
    this.selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.selectedPlateStepsMap.set(step.step, step);
      }
    )
  }

  prepareProcessStepMapforMultiPlateUpdate(selectedPlate : Plate){
    this.multiPlateStepsMap = new Map();
    if(!selectedPlate.processSteps || selectedPlate.processSteps==null)
      return;
    selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiPlateStepsMap.set(step.step, step);
    });
    this.multiPlateStepsMapList.push(this.multiPlateStepsMap);
  }

  isValidProcessStep(stepName: string): boolean {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return (stepsMap.get(tempStepName) != undefined && stepsMap.get(tempStepName) != null);
  }

  isValidProcessStepAction(stepName: string){
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return (stepsMap.get(tempStepName) != undefined && stepsMap.get(tempStepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return stepsMap.get(tempStepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return stepsMap.get(tempStepName).endPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return this.multiPlate ? stepsMap.get(tempStepName).startTimeStamp : this.convertUtcToLocal(stepsMap.get(tempStepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return this.multiPlate ? stepsMap.get(tempStepName).endTimeStamp : this.convertUtcToLocal(stepsMap.get(tempStepName).endTimeStamp);
  }

  getProcessStepActionPuid(stepName: string, actionName: string){
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return stepsMap.get(tempStepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string){
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;

    var tempStepName = stepName
    return this.multiPlate ? stepsMap.get(tempStepName).actionMap.get(actionName).actionStartTime : this.convertUtcToLocal(stepsMap.get(tempStepName).actionMap.get(actionName).actionStartTime);
  }

  findTheStepName(stepName:string,stepsMap:Map<string,Step>):string{
    var tempStepName = "";
    if(!stepsMap.get(stepName) || !stepsMap.get(stepName).startTimeStamp){
      tempStepName = stepName == "AMPLIFY_WGA"?"AMPLIFY_PGX":stepName == "AMPLIFY_PGX"?"AMPLIFY_WGA":stepName;
    }else{
      tempStepName = stepName;
    }
    return tempStepName;
  }

  showWarningMessage(stepName:string,actionName:string){
    let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
    let actionRunTime: number = this.selectedPlateStepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
     if(this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime))>"00:00:00"){
      this._messagesService.addWarningMessage({
              severity: 'warn', summary: 'Timer is not at ZERO!',
              detail: "The time for action button is still running!",
            });
          }
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string) {
    var stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    var tempStepName = stepName
    if (stepsMap.get(tempStepName).actionMap && stepsMap.get(tempStepName).actionMap.get(actionName) != undefined && stepsMap.get(tempStepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(tempStepName, actionName);
      let actionRunTime: number = stepsMap.get(tempStepName).actionMap.get(actionName).actionRunTime;
      return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
    } else {
      let actionRunTime = (this.viewType == BeadChipProcessFlows.AXIOM_384)  ? this.mapOfActionRuntimeAxiom384.get(actionName) : this.mapOfActionRuntime.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  checkProcessFlowProperties(){
    this.selectedProcessFlows = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    let ps = PlateStatus;
    this.statusFilterList = [ps.ALIQUOTATION_STARTED, ps.ALIQUOTATION_COMPLETED, ps.START_PREPCR, ps.STORED, ps.WGA_STARTED, ps.WGA_COMPLETED, ps.PGX_COMPLETED, ps.PREPCR_COMPLETED, ps.RECOMBINING_COMPLETED, ps.RECOMBINING_STARTED, ps.FRAGMENTATION_STARTED,
      ps.FRAGMENTATION_COMPLETED, ps.PRECIPITATION_STARTED, ps.PRECIPITATION_COMPLETED, ps.RESUSPENDING_STARTED, ps.RESUSPENDING_COMPLETED];
    let isQCScanActive = false, isExtractionActive = false, isAxiom384Propel = false, isIllumina = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      let x = this.selectedProcessFlows[i]
      if(x.qcScan)
        isQCScanActive = true;
      if(x.okTOpureHair || x.okTOpureEartag || x.ExEartagTLR)
        isExtractionActive = true;
      if(x.axiom384Propel){
        isAxiom384Propel = true;
      }
      if(x.illuminaExInfinium){
        isIllumina = true;
      }
    }
    if(!isQCScanActive && !isExtractionActive && isIllumina){
      this.statusFilterList.push(ps.RECEIVED, ps.RECEPTION_COMPLETED)
    }
    else if(isExtractionActive){
      this.statusFilterList.push(ps.EXTRACTION_COMPLETED, ps.MERGE_COMPLETED)
    }
    else if(isQCScanActive){
      this.statusFilterList.push(ps.QCSCAN_COMPLETED)
    }
    if(isAxiom384Propel){
      this.statusFilterList.push(ps.DENATURATION_STARTED,ps.DENATURATION_COMPLETED);
      this.filterOptions = axiom384PropelStatusFilter;
    }
    else if(isIllumina){
      this.filterOptions = illuminaExInfiniumStatusFilter;
    }
    if(this.isPlatePreparationSelectedFromSamplesComponent){
      this.onApplyFilter();
      this.isPlatePreparationSelectedFromSamplesComponent = false;
    }
    return true
  }

  preparePlateSearchDTO(labId:string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate!==null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US')
    }
    return plateListDTO;
  }

  fetchReceivedPlates(status?: string, workFlow?: string) {
    this.loading = true;
    if(status === '' || status == undefined){
      status = this.statusFilterList.join(',');
    }
    if(workFlow === ''){
      workFlow = undefined;
    }
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE" ,status, workFlow, this.fromDate)).subscribe({
      next: (result) => {
        this.plates = result;
        this.loading = false;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error) => {
        this.loading = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }
    })
  }

  isCommentAdditionDisabled() {
    if(this.selectedPlate){
      return true;
    }
    return false;
  }


  searchForPlate() {
    this.plateBtn1="enabeledd";
    if(!this.plateToSearch || this.plateToSearch===''){
      this.removePlateSelection();
      return;
    }
    this.searchForPlateAction(this.plateToSearch);
    this.plateToSearch="";
  }

  searchForSample() {
    this.isVisible = false;
    this.plateBtn1 = "enabeledd";
    if (!this.sampleToSearch && this.sampleToSearch === '') {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId, this.sampleToSearch).subscribe({
      next: (result) => {
        let sample = result.data[0]
        let sample_id = sample['_id']
        this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId).subscribe({
          next: (result) => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', detail: 'Sample search success!'
            })
            this.selectedPlate = result;
            this.prepareProcessStepsMap();
            this.selectPlateView(this.selectedPlate.workFlow, this.selectedPlate.processFlowName, this.selectedPlate.beadChips);
            this.multiPlate = false;
            this.sampleToSearch = "";
            if (PlateStatus.PLATE_REDO == this.selectedPlate.status) {
              this._messagesService.addWarningMessage({
                severity: 'warn', summary: "Cannot process the current plate!!"
              })
              return;
            }
            this.prepareProcessStepsMap();
          }, error: (error) => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failed to fetch plate info',
              detail: error.error.error
            })
          }
        })
      }, error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error.error
        })
      }
    })
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean{
    if(this.selectedPlateStepsMap.has(step)){
      var existingStep = this.selectedPlate.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = (this.viewType == BeadChipProcessFlows.AXIOM_384)  ? this.mapOfActionRuntimeAxiom384.get(actionName) : this.mapOfActionRuntime.get(actionName);
          existingStep.action.push(newAction);
        }
      }
    }else{
      this.selectedPlate.processSteps = (!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null) ? [] : this.selectedPlate.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
        newStep.action = [];
        newStep.chemicals=[];

      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedPlate.processSteps.push(newStep)
    }
    return true;
  }

  updateMultiPlateUpdateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler=""){
    if(this.multiUpdateProcessStepsMap.has(step)){
      var existingStep = this.multiUpdateProcessStepsMap.get(step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = (this.viewType == BeadChipProcessFlows.AXIOM_384)  ? this.mapOfActionRuntimeAxiom384.get(actionName) : this.mapOfActionRuntime.get(actionName);
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction)
        }
      }
    }else{
      var newStep = new Step();
      newStep.step = step;
      newStep.action = [];
      newStep.actionMap = new Map();
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        newStep.endTimeStamp = new Date();
        newStep.endPUID = this.puid;
      }else{
        var newAction = new StepAction();
        newAction.action = actionName;
        newAction.actionPUID = this.puid;
        newAction.actionStartTime = new Date();
        newAction.actionRunTime = (this.viewType == BeadChipProcessFlows.AXIOM_384)  ? this.mapOfActionRuntimeAxiom384.get(actionName) : this.mapOfActionRuntime.get(actionName);
        newStep.actionMap.set(actionName, newAction);
      }
      this.multiUpdateProcessStepsMap.set(step, newStep)
    }
  }

  fetchDataForPlateView() {

  }

  getExcel() {

  }

  puidPopupMethod(status: string) {
    this.enteredPassword = "";
    this.enteredPuid = "";
    this.enteredPasswordToByeArray = [];
    this.puidPopup = true;
    this.puidPopupFunction = status;
  }

  showChemicalPopup(processStep?: string) {

    this.selectedProcessStep = processStep;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next: (result) => {
        this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
      }, error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    });

    if(this.selectedPlate.status && !this.mapOfProcessStepsStatus.get(this.selectedPlate.status).includes(processStep) || this.selectedPlate.status == null){
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    if(this.lastUpdatedStatus && this.multiPlate && this.mapOfProcessStepsStatus.get(this.lastUpdatedStatus).includes(processStep) && this.lastUpdatedStatus != null && this.lastUpdatedStatus != ''){
      this.multiChemicalEdit = true;
    } else {
      this.multiChemicalEdit = false;
    }

    this.showDialogue= true;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,this.selectedPlate.plateID).subscribe({
      next:(result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
        this.showCommentDialog = true;
      },
      error:(error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })

  }

  hideDialog(reloadPlateData: boolean = false){
    if(reloadPlateData){
      this.searchForPlateAction(this.selectedPlate.lastUpdatedPlateID)
    }
    this.showCommentDialog = false;
  }

  showMultiComments(){
    this.showMultipleCommentDialog = true;
  }

  saveMultiCommentEnabled(){
    return (this.newMultiComment == null || this.newMultiComment.trim() == '')
  }

  saveMultiComment(){
    let multiComment = new MultiCommentDTO();
    multiComment.beadchipids = []
    multiComment.beadchipstatus = ""
    multiComment.comment = this.newMultiComment;
    multiComment.labid = this.selectedLabId;
    multiComment.platecomment = true;
    multiComment.puid = this.puid;
    multiComment.status = this.lastUpdatedStatus;
    multiComment.plateids = this.chemicalsPlateids;

    this.platePreparationService.updateMultiComment(multiComment).subscribe({
      next:(result) =>{
        this.newMultiComment = "";
        this.showMultipleCommentDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      error:(error) =>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    });
  }

  hideChemicalDialog(plate: Plate){
    this.showDialogue = false;
    if (plate.plateID !== undefined)
    this.searchForPlateAction(plate.plateID)
  }

  updatePlateData(plate: Plate){
    this.selectedPlate = plate;
    this.selectPlateView(this.selectedPlate.workFlow, this.selectedPlate.processFlowName, this.selectedPlate.beadChips);
    if(PlateStatus.PLATE_REDO == this.selectedPlate.status){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:"Cannot process the current plate!!"
      })
      return;
    }
    this.prepareProcessStepsMap();
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  getPlateDisplayValue(plate:Plate){
    return plate.lastUpdatedPlateID;
  }

  getPlateValue() {
    return this.selectedPlate.lastUpdatedPlateID
  }

  //upload
  onFileSelect(filesData) {
    if (filesData.target.files.length > 0) {
      const file = filesData.target.files[0];
      this.uploadedFile = file;
      let fileReader: FileReader = new FileReader();
      let self = this
      fileReader.onloadend = function(x) {
        self.uploadedFileContent = fileReader.result
        self.isFileNotSelected = false
      }
      fileReader.readAsText(file)
    } else {
      this.isFileNotSelected = true;
    }
  }

  fileUpload() {
    this.blocked = true;
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    this.platePreparationService.logFileUpload(this.uploadedFileContent, this.selectedLabId, this.puid).subscribe({
      next:results => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "Success", detail: results["data"]
        });
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        if(this.selectedPlate.plateID){
          this.searchForPlateAction(this.selectedPlate.plateID);
        }
        this.onApplyFilter();
      },
      error:error => {
        this.fileUploadElement.nativeElement.value = "";
        this.isFileNotSelected = true;
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error',
        summary: "Conflict", detail:error.error});
      }
    });
  }

  fetchSingleStorageBasedOnProcessSteps(step: string){
    if(step === ProcessStep.PRECIPITATE_SAFE_STOPPING){
      if(this.precipitateDnaStorageList.length !== 1){
        return null
      }
      return this.precipitateDnaStorageList[0]
    }
    else if(step === ProcessStep.STORE_PGX_PLATE){
      if(this.recombineDnaStorageList.length !== 1){
        return null
      }
      return this.recombineDnaStorageList[0]
    }
    else if(step === ProcessStep.RESUSPEND_SAFE_STOPPING){
      if(this.resuspendDnaStorageList.length !== 1){
        return null
      }
      return this.resuspendDnaStorageList[0]
    }
    else if(step === ProcessStep.FRAGMENT_SAFE_STOPPING){
      if(this.fragmentDnaStorageList.length !== 1){
        return null
      }
      return this.fragmentDnaStorageList[0]
    }
    else return null
  }

  getStorageLocations(step: string = "") {
    this.blocked = true
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId, step).subscribe({
      next:result => {
        this.blocked = false
        this.storageList = result.datalist;
        let storageGroups = this.storageList.groupBy('processStep')
        this.recombineDnaStorageList = storageGroups["RECOMBINE_DNA"] || []
        this.fragmentDnaStorageList = storageGroups["FRAGMENT_DNA"] || []
        this.precipitateDnaStorageList = storageGroups["PRECIPITATE_DNA"] || []
        this.resuspendDnaStorageList = storageGroups["RESUSPEND_DNA"] || []
      },error:error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:"error",summary:"Error while fetching storage's",
          detail:"Something went wrong while fetching storages. Please try again." + this.showError(error)
        })
      }
    })
  }

  getProcessStepLiquidHandler(stepName){
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName) ? stepsMap.get(stepName).liquidHandler : "";
  }

  clearLiquidHandlerValues(){
    this.amplifyLiquidHandler = '';
    this.recombineLiquidHandler = '';
    this.precipitateLiquidHandler = '';
    this.resuspendLiquidHandler = '';
    this.multiLiquidHandler = '';
    this.aliquotPlateID = '';
  }

  updateMachine(barcode, status, workFlow){
    if(barcode != '' || barcode == null){
      let selectedMachine = this.machinesList.find(element => barcode===element.barcode);
      if(selectedMachine !== undefined){
        selectedMachine.latestProcessStep = this.machineProcessStepStatusMap.get(status);
        selectedMachine.latestProcessStepTimeStamp = new Date();
        selectedMachine.latestWorkFlow = workFlow;
        this.blocked = false;
        this.masterDataService.updateConfig(selectedMachine.lab, selectedMachine, "machine").subscribe({
          next:results => {
            this.blocked = false;
            if (!results) {
              return;
            }
            this.machinesList[this.machinesList.indexOf(selectedMachine)] = results.data
          },
          error:error => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Error in updating Machine',
              detail: "Error in updating machine status."
            });
          }
        });
      }
      else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Machine Does Not Exists',
          detail: "Machine with the given barcode does not exist."
        });
      }
    }
  }

  convertToNumber(str: string){
    return Number(str)
  }

  processStepViewDecider(viewType: string) : boolean {
    return (this.viewType == viewType);
  }

  getAllProcessFlows() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe({next:results => {
      this.blocked = false;
      if(results && results.data){
        this.processFlows = results.data;
      }
    },error: error => {
      this.blocked = false;
      this.showError(error);
    }})
  }

  selectPlateView(workFlow, processFlowName, beadChips) {
    let workflowName = workFlow;
    let selectedWorkflow = this.getSelectedWorkFlow(workflowName);
    if(!selectedWorkflow){
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No workflow found for plate'});
      this.plateViewSelectionDone = false;
      return;
    }
    this.platePreparationService.getProcessFlow(processFlowName, this.selectedLabId).subscribe({
      next: result => {
        if (result.data) {
          this.selectedProcessFlow = result.data;
          if (this.selectedProcessFlow.axiom384Propel && this.selectedProcessFlow.manualPreparation) {
            this.viewType = BeadChipProcessFlows.AXIOM_384;
          } else {
            this.viewType = BeadChipProcessFlows.OLD_FLOW;
          }
          this.plateViewSelectionDone = true;
          if (Number(this.selectedProcessFlow.beadChipSize) == 384 && this.viewType == BeadChipProcessFlows.AXIOM_384 && beadChips.length > 0) {
            this.beadChipID = beadChips[0].beadChipID
            this.platePreparationService.fetchPlate(this.beadChipID, this.selectedLabId).subscribe(res => {
              this.beadChipDetails = res
            })
          }
        } else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No process flow found',
            detail: 'Either no configured process flow in MDM or no sample type in plate.'
          });
          this.viewType = null;
          this.plateViewSelectionDone = false;
        }
      },
      error: error => {
        this.blocked = false;
        this.plateViewSelectionDone = false;
        this.showError(error);
      }
    });
  }

  getSelectedWorkFlow(workFlowName: string) : WorkFlow{
    let workflow = null;

    for(let wf of this.workFlowData) {
      if(wf.workFlowName == workFlowName) {
        workflow = wf;
        break;
      }
    }
    return workflow;
  }
  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }
}
